/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/learningContent/learningContentUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */

import { LESSONS_URL_FRAGMENT, TRACKS_URL_FRAGMENT } from '../../constants/Navigation.legacy';
import { getPlaylistUrl } from '../../utils/RoutingUtils.migrated';
import { getShortContentUrl } from '../shortContent/shortContentRouting.migrated';
const getLearningContentItemPath = ({
  id,
  type
}) => {
  switch (type) {
    case 'TRACK':
      return `${TRACKS_URL_FRAGMENT}/${id}`;
    case 'LESSON':
      return `${LESSONS_URL_FRAGMENT}/${id}`;
    case 'PLAYLIST':
    case 'LEARNING_PATH':
      return getPlaylistUrl(id);
    case 'SHORT_FORM_CONTENT':
      return getShortContentUrl({
        shortId: id
      }).fullUrl;
    default:
      return '';
  }
};
const getLearningContentItemSearchParams = ({
  type,
  language
}) => {
  const search = new URLSearchParams();
  if (language) search.set('language', language);
  switch (type) {
    case 'TRACK':
    case 'LESSON':
      return search.toString();
    default:
      return null;
  }
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/learningContent/learningContentUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const getLearningContentItemUrl = item => {
  const params = getLearningContentItemSearchParams(item);
  return `${getLearningContentItemPath(item)}${params ? `?${params}` : ''}`;
};